import { Injectable } from '@angular/core';
import { environment as environmentConfig } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentVariablesService {
  auth0Config: Record<string, string> = {};
  productionURL!: string;
  // Get array of locations where we have to send logs
  loggingTargets: string[] = [];
  contentful: Record<string, boolean | string | number> = {};
  sessionStandAloneTime!: number;
  proxy!: Record<string, unknown>;
  googleAnalyticsID!: string;
  notificationConfig: Record<string, boolean> = {};
  clientDocs!: string;
  hideDatesPriorToDate!: string;
  assetsFolderPath = '';
  externalUris: Record<string, string> = {};
  arsUri!: string;
  appsUrl = '';
  profileUrl = '';
  disableEasyAuth!: boolean;
  showLoginBanner!: boolean;
  showCommingledExperience!: boolean;

  constructor() {
    this.setEnvironmentConfig();
  }

  setEnvironmentConfig = () => {
    this.proxy = environmentConfig.proxy as unknown as Record<string, unknown>;
    this.contentful = environmentConfig.contentful as unknown as Record<string, boolean | string | number>;
    this.sessionStandAloneTime = environmentConfig.sessionStandAloneTime as unknown as number;
    this.productionURL = location.origin;
    this.googleAnalyticsID = environmentConfig.googleAnalyticsID;
    this.auth0Config = environmentConfig.auth0Config as unknown as Record<string, string>;
    this.loggingTargets = environmentConfig.loggingTargets as unknown as string[];
    this.notificationConfig = environmentConfig.notificationConfig as unknown as Record<string, boolean>;
    this.clientDocs = environmentConfig.clientDocs;
    this.hideDatesPriorToDate = environmentConfig.hideDatesPriorToDate;
    this.assetsFolderPath = environmentConfig.assetsFolderPath;
    this.externalUris = environmentConfig.externalUris as unknown as Record<string, string>;
    this.arsUri = environmentConfig.ars as unknown as string;
    this.appsUrl = environmentConfig.appsUrl;
    this.profileUrl = `${this.appsUrl}/profile`;
    this.disableEasyAuth = environmentConfig.disableEasyAuth;
    this.showLoginBanner = String(environmentConfig.showLoginBanner) === 'true';
    this.showCommingledExperience = String(environmentConfig.showCommingledExperience) === 'true';
  }
}
